const USER_SURVEY_FOR_ORDER_LIST = 'https://forms.gle/8LUPyVYD8mZeZaEh7';

export default {
  USER_SURVEY_FOR_ORDER_LIST,
};
